<table cellspacing="0" class="trips-table">
  <thead>
    <tr>
      <th>{{ 'MergeTripTab.StartLocation' | translate }}</th>
      <th>{{ 'MergeTripTab.StartTime' | translate }}</th>
      <th>{{ 'MergeTripTab.EndLocation' | translate }}</th>
      <th>{{ 'MergeTripTab.EndTime' | translate }}</th>
      <th>{{ 'MergeTripTab.Purpose' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (trip of tripsToMerge; track trip.TripID) {
      <tr>
        <td>
          <div class="trips-table__body--location">
            @if (mergeTripForm?.controls?.[trip.TripID.toString()]) {
              @let tripControl =
                mergeTripForm!.controls[trip.TripID.toString()];
              <dv-checkbox
                [disabled]="tripControl.disabled"
                [checked]="!!tripControl.value"
                (checkedChange)="
                  tripControl.setValue(!!$event); tripControl.markAsDirty()
                ">
              </dv-checkbox>
            }
            {{ trip.StartLocation }}
          </div>
        </td>
        <td>{{ trip.StartTime | date: 'dd.MM.yyyy H:mm' }}</td>
        <td>{{ trip.EndLocation }}</td>
        <td>{{ trip.EndTime | date: 'dd.MM.yyyy H:mm' }}</td>
        <td>{{ trip.Purpose }}</td>
      </tr>
    }
  </tbody>
</table>
